import { render, staticRenderFns } from "./ListaFNRH.vue?vue&type=template&id=bfd78cdc&scoped=true&"
import script from "./ListaFNRH.vue?vue&type=script&lang=js&"
export * from "./ListaFNRH.vue?vue&type=script&lang=js&"
import style0 from "./ListaFNRH.vue?vue&type=style&index=0&id=bfd78cdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfd78cdc",
  null
  
)

export default component.exports